export default {
  signIn: {
    welcome: 'Welcome',
    welcomeText: 'Shriram Parivaar Admin Panel',
    title: 'Sign in',
    signInError: 'Failed to sign in!. Please try again',
    forgotPassword: 'Forgot Password?',
    forgotPasswordSubtext: `,Enter your registered email address. We'll send you a link to reset your password.`,
    sendResetLinkError: 'Failed to send reset link. Please try again.',
    sendResetLink: 'Failed to authenticate the email ID. Please try again.',
    backToSignIn: 'Back to Sign In',
    resetPassword: 'Reset Password',
    forgotPasswordSuccesssDialogTitle: 'Email Sent',
    forgotPasswordSuccess: 'Reset link sent! Please check your email.',
    resetPasswordSuccessDialogTitle: 'Password Updated',
    resetPasswordSuccess: 'Password reset successfully!. Please login with your new password.',
    resetPasswordError: 'Failed to reset password. Please try again.',
    reset: 'Reset',
    emailLabel: 'Email:',
    passwordLabel: 'Password:',
    signInButton: 'Sign In',
  },
  auth: {
    sessionExpired: 'Session expired. Please login again.',
    loginFailed: 'Login failed. Please check your credentials and try again.',
    logoutDialogTitle: 'Confirm Logout',
    logoutDialogMessage: 'Are you sure you want to logout?',
  },
  buttonTitles: {
    submit: 'Submit',
    cancel: 'Cancel',
    close: 'Close',
    add: 'Add',
    save: 'Save',
    filter: 'Filter',
    apply: 'Apply',
    clear: 'Clear',
    sortBy: 'Sort By',
    Okay: 'Okay',
    download: 'Download',
  },
  generalContent: {
    upload: 'Drag and drop or ',
    click: 'click to upload',
    noData: 'No data to display',
    copied: 'Copied',
  },
  navbar: {
    eventAnalytics: 'Analytics',
    overview: 'Overview',
    userEngagements: 'User Engagements',
    pagesAndScreens: 'Pages and Screens',
    user: 'User',
    projectDetails: 'Project Details',
    projects: 'Projects',
    clusers: 'Clusters',
    towers: 'Towers',
    units: 'Units',
    projectUpdates: 'Project Updates',
    content: 'Content',
    helpAndSupport: 'Help & Support',
    admin: 'Admin',
    logout: 'Logout',
    logoutError: 'Failed to logout',
  },
  userModule: {
    pageTitle: 'Shriram Parivaar App Users',
    viewReceipts: 'VIEW RECEIPTS',
    eventFailed: 'Failed to load event details',
    appDetailsFailed: 'Failed to load app details',
    screenVisits: 'Screen Visits',
    userListError: 'Failed to fetch users!',
  },
  analytics: {
    overviewPageTitle: 'Shriram Parivaar App Analytics',
    eventDetailsPageTitle: 'User Engagement Details',
    pagesAndAndScreens: 'Pages and Screens',
    userEngagements: 'User Engagements',
    kpisError: 'Failed to fetch analytics',
    eventsChartError: 'Failed to fetch events report',
    eventsError: 'Failed to fetch user engagements report',
    pagesAndScreensError: 'Failed to fetch pages and screens report',
    eventDetailsError: 'Failed to fetch user engagement details',
    noEventDetails: 'Details not available',
    appInstallationAnalyticsError: 'Failed to fetch app installation analytics',
    downloadReportError: 'Failed to download the report. Please try again.',
    downloadReporSuccess: 'Report downloaded successfully!',
    definitions: {
      total_users:
        'Approximate number of unique users who used the app, including both new and returning users. Counts can vary due to multiple devices, reinstalls, or app data resets.',
      active_users:
        'Number of users who actively interacted with the app. This can sometimes exceed download counts because returning users, multiple devices, reinstalls, and restored app data may be counted separately.',
      new_users:
        'Number of users who opened or interacted with the app for the first time. This is based on analytics tracking, not exact store installs, so reinstalls or app resets may create duplicate counts.',
      event_count:
        'Total number of tracked interactions in the app. A single user can trigger multiple interactions repeatedly, so this value is usually much higher than the user count.',
      avg_engagement_time_per_user: 'Average active time spent by each user on the app',
      engaged_sessions_per_active_user:
        'Average number of meaningful (engaged) sessions per user. A session is considered engaged if it lasts longer than 10 seconds, performs a key action in the app, or has 2 or more screen views.',
      avg_engagement_time_per_session: 'Average active engagement time per session',
      sessions:
        'Total number of sessions started by users. A session begins when a user opens the app and ends after inactivity (typically 30 minutes) or when the app is closed.',
      views_per_session: 'Average number of screens viewed per session',
      event_count_per_user: 'Average engagements per user',
      screen_page_views_per_user: 'Average number of screens viewed per user',
      pageviews: 'Total visits to the screen',
      active_users_of_page: 'Number of users who viewed the screen',
      screenviews_per_active_user: 'Average number of views per user',
      avg_engagement_time_of_page: 'Avg. time spent on screen',
      event_count_on_page: 'Total number of tracked interactions on screen',
      userEngagementsByCount: 'User engagements are calculated from user interactions (clicks), not distinct users.',
      userEnegagementsByActivity: 'Based on total unique users identified by Google Analytics.',
    },
  },
  projectHierarchy: {
    fileUploadSuccess: 'Projects File uploaded successfully',
    fileUploadFailure: 'Failed to upload project file. Please try again.',
    uploadProjects: 'Upload Projects',
    uploadProjectsInstruction:
      'Ensure city names match exactly with Google Analytics before upload. Otherwise, they must be manually updated in the database. Mismatches may lead to incorrect reports in analytics.',
    projectsFetchFailure: 'Failed to fetch projects',
    clustersFetchFailure: 'Failed to fetch clusters',
    towersFetchFailure: 'Failed to fetch towers',
    unitsFetchFailure: 'Failed to fetch units',
    projectActions: {
      editText: 'Edit Project',
      deleteText: 'Delete Project',
    },
    clusterActions: {
      editText: 'Edit Cluster',
      deleteText: 'Delete Cluster',
    },
    towerActions: {
      editText: 'Edit Tower',
      deleteText: 'Delete Tower',
    },
    unitActions: {
      editText: 'Edit Unit',
      deleteText: 'Delete Unit',
    },
    deleteProjectWarning: {
      title: 'Delete this project?',
      message:
        'This action will permanently delete all clusters, towers, and units under this project',
    },
    deleteClusterWarning: {
      title: 'Delete this cluster?',
      message: 'This action will permanently delete all towers, and units under this cluster',
    },
    deleteTowerWarning: {
      title: 'Delete this tower?',
      message: 'This action will permanently delete all units under this project',
    },
    deleteUnitWarning: {
      title: 'Delete this unit?',
      message: 'This action will permanently delete the unit and cannot be undone',
    },
    definitions: {
      recordStatus: 'Indicates whether this record is active in our system. Inactive records are hidden from the mobile app and all project listings. Deleted records are permanently excluded.',
      projectStatus: 'Current project phase as maintained in Salesforce (SFDC).',
    }
  },
  projectUpdates: {
    projectwiseAnalyticsTitle: 'Projectwise Analytics',
    userEnagementsPerReport: 'User Engagements per Report',
    userEnagementsPerVideo: 'User Engagements per Video',
    projectUpdatesFetchFailure: 'Failed to fetch project updates',
    defaultText: 'Steady Steps Forward',
    defaultSubText: `Here's the project progress update for`,
    addproject: 'Add Project Updates',
    projectListError: 'Failed to fetch Project List',
    cityFetchError: 'Failed to fetch Cities',
    projectUpdateSuccess: 'Project update published successfully!',
    projectUpdateError: 'Failed to upload project update. Please try again.',
    projectwiseAnalyticsError: 'Failed to fetch projectwise analytics',
    definitions: {
      reports: {
        event_count_per_user: 'Average number of report view engagements triggered by each user',
        events_last_30_mins:
          'Number of report view engagements recorded in the last 30 minutes in real time',
        total_users: 'Number of unique users who viewed the reports',
        total_events: 'Total number of times the reports were viewed',
      },
      videos: {
        event_count_per_user: 'Average number of video view engagements triggered by each user',
        events_last_30_mins:
          'Number of video view engagements recorded in the last 30 minutes in real time',
        total_users: 'Number of unique users who viewed the videos',
        total_events: 'Total number of times the videos were viewed',
      },
    },
  },
  status: {
    success: 'Successful!',
    error: 'Error!',
    warning: 'Warning!',
    info: 'Info',
    delete: 'Delete This File?',
  },
  admin: {
    screenTitle: 'Admin Management',
    createAdmin: 'Add Admin ',
    editAdmin: 'Edit Admin',
    deleteAdmin: 'Delete Admin',
    editName: 'Edit Name',
    resetPassword: 'Reset Password',
    fetchRolesError: 'Failed to fetch roles. Please try again.',
    fetchPermissionsError: 'Failed to fetch permissions. Please try again.',
    fetchAdminsError: 'Failed to fetch admins. Please try again.',
    adminDeletionSuccess: 'Admin deleted successfully!',
    adminDeletionFailure: 'Failed to delete admin. Please try again.',
    adminCreationSuccess: 'Admin created successfully!',
    adminCreationFailure: 'Failed to create admin. Please try again.',
    adminUpdationSuccess: 'Admin details updated successfully!',
    adminUpdationFailure: 'Failed to update admin details. Please try again.',
    profileUpdationSuccess: 'Profile updated successfully',
    profileUpdationError: 'Failed to update profile.',
    passwordUpdationSuccess:
      'Your password has been reset. Please login again with the new password.',
    passwordUpdationError: 'Failed to update password.',
  },
  content: {
    //App Contents
    currentContent: 'Current Content',
    newContent: 'New Content',
    noContent: 'No content available for this section.',
    selectContentType: 'Select Content Type',
    fetchScreenShotsError: 'Failed to fetch screen previews.',
    fetchContentsError: 'Failed to fatch content for the selected screen.',
    updateContentError: 'Failed to update content',
    updateContentSuccess: 'Content updated successfully',
    //FAQs
    faqs: 'FAQs',
    addCategory: 'Add Category',
    deleteCategory: 'Delete Category',
    renameCategory: 'Rename Category',
    categoryPlacegolder: 'Category Name',
    category: 'Category',
    subCategory: 'Sub-Category',
    addSubCategory: 'Add Sub-Category',
    deleteSubCategory: 'Delete Sub-Category',
    renameSubCategory: 'Rename Sub-Category',
    subcategoryPlacegolder: 'Sub-Category Name',
    question: 'Question',
    addQuestion: 'Add Question',
    editQuestion: 'Edit Question',
    answer: 'Answer',
    fetchFAQsError: 'Failed to fetch FAQs',
    createCategoryError: 'Failed to create category',
    editCategoryError: 'Failed to edit category',
    deleteCategoryError: 'Failed to delete category',
    createCategorySuccess: 'Category created successfully',
    editCategorySuccess: 'Category updated successfully',
    deleteCategorySuccess: 'Category deleted successfully',
    createSubCategoryError: 'Failed to create sub-category',
    editSubCategoryError: 'Failed to edit sub-category',
    deleteSubCategoryError: 'Failed to delete sub-category',
    createSubCategorySuccess: 'Sub-Category created successfully',
    editSubCategorySuccess: 'Sub-Category updated successfully',
    deleteSubCategorySuccess: 'Sub-Category deleted successfully',
    createQnAError: 'Failed to create FAQ',
    editQnAError: 'Failed to edit FAQ',
    deleteQnAError: 'Failed to delete FAQ',
    createFAQSuccess: 'FAQ created successfully',
    editFAQSuccess: 'FAQ updated successfully',
    deleteQnASuccess: 'FAQ deleted successfully',
    //Care Fair Events
    addEvent: 'Add Event',
    careFairEvents: 'Care Fair Events',
    careFairEvent: 'Care Fair Event',
    careFairEventsRegistrationLink: 'Registration Link',
    fetchEventsError: 'Failed fetch to fetch event list',
    createEventError: 'Failed to create event.',
    editEventError: 'Failed to update event details',
    createEventSuccess: 'Event created successfully!',
    editEventSuccess: 'Event updated successfully!',
    deleteEventSuccess: 'Event deleted successfully!',
    deleteEventError: 'Failed to delete event. Please try again.',
  },
  reviews: {
    screenTitle: 'Help & Support',
    reviewsTitle: 'Reviews',
    addReply: 'Add Reply',
    editReply: 'Edit Reply',
    replySuccess: 'Reply sent successfully!',
    replyError: 'Failed to send the reply. Please try again.',
    reviewDetailsFetchError: 'Failed to fetch review details.',
    reviewsFetchError: 'Failed to fetch reviews.',
  },
};
